import { v4 as uuid } from 'uuid';

import type { OpeningHoursNode } from 'components/powerFlowShared/components/nodeTypes/canvas/openingHours';

import { FlowNodeTypes } from '../../../types';
import type { BusinessHoursNode } from '../../businesshours/businesshours';

export function createBusinessHoursNode(
  node: OpeningHoursNode,
  scheduleId: string,
): BusinessHoursNode {
  const { payload } = node;

  return {
    ...node,
    nodeType: FlowNodeTypes.BUSINESS_HOURS,
    text: 'Business hours',
    icon: 'clock',
    isRemovable: false,
    payload: {
      scheduleId: scheduleId,
      hangUpAfterAnnouncement: false,
      closedNodeId: uuid(),
      openNodeId: payload?.openNodeId || uuid(),
    },
  };
}
